/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffDtoBffBoCodePostResponse
 */
export interface JpCoBenefitoneBsdpBffDtoBffBoCodePostResponse {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffDtoBffBoCodePostResponse
     */
    boCode?: string;
}

export function JpCoBenefitoneBsdpBffDtoBffBoCodePostResponseFromJSON(json: any): JpCoBenefitoneBsdpBffDtoBffBoCodePostResponse {
    return JpCoBenefitoneBsdpBffDtoBffBoCodePostResponseFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffDtoBffBoCodePostResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffDtoBffBoCodePostResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'boCode': !exists(json, 'boCode') ? undefined : json['boCode'],
    };
}

export function JpCoBenefitoneBsdpBffDtoBffBoCodePostResponseToJSON(value?: JpCoBenefitoneBsdpBffDtoBffBoCodePostResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'boCode': value.boCode,
    };
}

